<div class="ng-autocomplete">
  <ng-autocomplete
    [data]="data"
    [searchKeyword]="keyword"
    [initialValue]="initialValue"
    placeholder="Enter the ID"
    (selected)="selectEvent($event)"
    (inputChanged)="onChangeSearch($event)"
    historyIdentifier="data"
    [itemTemplate]="itemTemplate"
    [notFoundTemplate]="notFoundTemplate"
    #auto
  >
  </ng-autocomplete>

  <ng-template #itemTemplate let-item>
    <a [innerHTML]="item[keyword]"></a>
  </ng-template>

  <ng-template #notFoundTemplate let-notFound>
    <div [innerHTML]="notFound"></div>
  </ng-template>
</div>
